<template>
    <div class=no-route>
        <div class="error-container">
            <div class="error-image">
                <img src="@/assets/images/error/expire.png" alt="">
            </div>
            <div class="error-tips">
                <div>该账号还未添加可访问的菜单，请联系管理员添加，并重新登录</div>
                <span class="wl-btn" @click="relogin">重新登录</span>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "no-route",
        data() {
            return {}
        },
        created() {

        },
        mounted() {

        },
        methods: {
            relogin(){
                this.$store.dispatch('user/resetToken')
                this.$nextTick(() => {
                    this.$router.push({
                        path: '/login'
                    })
                })
            }
        },
    }
</script>

<style lang="scss">
    .no-route {
        height: 100%;
        width: 100%;
        position: relative;
        .error-container{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            text-align: center;
            .error-tips{
                padding-top: 10px;
                a{
                    color: $mainColor;
                }
                a:hover{
                    text-decoration: underline;
                }
            }
            .wl-btn{
                margin-top: 20px;
            }
        }
    }
</style>